var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniswap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3238 42.5698C87.7894 43.9851 85.3613 43.9272 83.9005 42.4407L79.9333 38.4034C74.0901 32.4573 64.3779 32.2258 58.2404 37.8866L31.6082 62.4489L56.8634 63.0505C58.9813 63.101 60.656 64.8053 60.6039 66.8571C60.5519 68.909 58.7927 70.5313 56.6748 70.4808L22.1616 69.6586C20.0437 69.6081 18.369 67.9038 18.4211 65.8519L19.2699 32.4162C19.3219 30.3643 21.0811 28.7419 23.199 28.7923C25.3169 28.8428 26.9915 30.547 26.9395 32.5988L26.3184 57.0658L52.9504 32.5035C62.1571 24.0124 76.7254 24.3595 85.4898 33.2786L89.4572 37.3159C90.9178 38.8024 90.8583 41.1547 89.3238 42.5698Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3649 77.1189C31.8993 75.7038 34.3274 75.7618 35.7879 77.2482L39.7554 81.2855C45.5983 87.2316 55.3108 87.4629 61.4483 81.8023L88.0805 57.24L62.8253 56.6381C60.7074 56.5879 59.0327 54.8836 59.0848 52.8318C59.1368 50.7799 60.896 49.1576 63.0139 49.2081L97.5271 50.0303C99.6451 50.0808 101.32 51.7851 101.267 53.8367L100.419 87.2727C100.367 89.3246 98.6075 90.9469 96.4895 90.8964C94.3719 90.8459 92.6972 89.1419 92.7493 87.0901L93.3702 62.6232L66.7383 87.1854C57.5316 95.6765 42.9633 95.3292 34.1989 86.4103L30.2315 82.373C28.7707 80.8862 28.8305 78.5342 30.3649 77.1189Z",
    fill: "url(#paint1_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -5.58008,
    y: 8.35543,
    width: 120.095,
    height: 92.1265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 5.17383,
    y: 31.207,
    width: 120.095,
    height: 92.1264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32.4688,
    y1: 71.7659,
    x2: 120.556,
    y2: 4.05567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6BE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6BE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 87.2199,
    y1: 47.9227,
    x2: -0.867698,
    y2: 115.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6BE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6BE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.688,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniswap);
export default __webpack_public_path__ + "static/media/uniswap.ba6f75a392b16a1af45f2f96b7e03587.svg";
export { ForwardRef as ReactComponent };